import {Controller} from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.initializeClickTracking()
  }

  initializeClickTracking() {
    // Find all clickable elements within the article
    const clickableElements = this.element.querySelectorAll('a, button')

    clickableElements.forEach((element) => {
      element.addEventListener('click', (event) => {
        this.trackClick(event, element)
      })
    })
  }

  trackClick(event, element) {
    const text = element.textContent.trim()
    const href = element.getAttribute('href')
    const type = element.tagName.toLowerCase()

    window.tfxEvent('articles_cta_click', {
      type,
      text,
      href
    })
  }
}
